// import { h, render } from 'preact';
import React from 'react';
import { createRoot } from 'react-dom/client';
import YotpoReviewsWidget from './yotpo-reviews-widget';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(<YotpoReviewsWidget {...data} />);
  };

  init();
};
